import { Injectable } from "@angular/core";
import { MultiCartFacade, OrderEntry } from "@spartacus/cart/base/root";
import { Observable } from "rxjs";

@Injectable()
export abstract class UdxMultiCartFacade extends MultiCartFacade {
    abstract addUdxEntry(
        userId: string,
        cartId: string,
        productCode: string,
        quantity: number,
        orderEntries: any[]
      ): void;

    abstract removeUdxEntry(
      userId: string,
      cartId: string,
      entryNumber: number | undefined,
      orderEntries: any[] | undefined,
    ): void;

    abstract updateUdxEntry(
      userId: string,
      cartId: string,
      entryNumber: number,
      quantity: number,
      orderEntries: any[]
    ): void;  

    abstract getLastEntries(
      cartId: string,
      productCode: string
      ): Observable<OrderEntry[] | undefined>;
}